import { NavLink } from "react-router-dom";
import {
  BookOpen,
  ClipboardList,
  LayoutDashboard,
  MessageCircle,
  Settings,
} from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/cn";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/subjects",  label: "Subjects",  icon: BookOpen },
  { to: "/chat",      label: "AI Tutor",  icon: MessageCircle },
  { to: "/tests",     label: "Tests",     icon: ClipboardList },
  { to: "/settings",  label: "Settings",  icon: Settings },
];

export function Sidebar() {
  return (
    <aside className="hidden lg:flex lg:w-60 lg:flex-col lg:border-r lg:border-border lg:bg-surface dark:lg:bg-bg">
      <nav className="flex flex-1 flex-col gap-0.5 p-3">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "group relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium",
                "transition-[color,background-color] duration-150",
                "active:translate-y-px",
                isActive
                  ? "text-brand"
                  : "text-text-muted hover:text-text hover:bg-surface-2",
              )
            }
          >
            {({ isActive }) => (
              <>
                {/* Active background -- shared layoutId for smooth transition
                    between active items as the user navigates */}
                {isActive ? (
                  <motion.span
                    layoutId="sidebar-active"
                    className="absolute inset-0 rounded-lg bg-brand-soft"
                    transition={{ type: "spring", stiffness: 380, damping: 30 }}
                  />
                ) : null}
                <Icon className="relative h-[18px] w-[18px] flex-shrink-0" />
                <span className="relative">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
